var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActionPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0002C0 8.47648 4.47783 3.99865 10.0015 3.99865H38.0005C43.5242 3.99865 48.002 8.47647 48.002 14.0002V41.9991C48.002 47.5228 43.5242 52.0006 38.0005 52.0006H10.0015C4.47783 52.0006 0 47.5228 0 41.9991V14.0002Z",
    fill: "#314158"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9947 37.9938C29.5178 37.9938 33.9951 33.5164 33.9951 27.9934C33.9951 22.4703 29.5178 17.9929 23.9947 17.9929C18.4716 17.9929 13.9943 22.4703 13.9943 27.9934C13.9943 33.5164 18.4716 37.9938 23.9947 37.9938Z",
    stroke: "white",
    strokeWidth: 1.99978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9946 21.9935V27.9944L27.9952 29.9947",
    stroke: "white",
    strokeWidth: 1.99978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActionPending);
export default __webpack_public_path__ + "static/media/dashboard-action-pending.b71d8c045bf027d139adb1c8124a5173.svg";
export { ForwardRef as ReactComponent };